import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { Storage } from '@ionic/storage';
import { AlertController } from '@ionic/angular';
import { HelperService } from 'src/app/core/services/helper.service';
import { IonInfiniteScroll } from '@ionic/angular';
import { debounceTime } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { MenuService } from 'src/app/core/services/menu.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { environment} from 'src/environments/environment';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from "@angular/material/dialog";
import { HttpClient } from '@angular/common/http';
export interface PeriodicElement {
  id:number;
  api_product_name:string; 
  api_Brand_name:string;
  type:string;
  api_business_object:string;
  method:string;
  select:string;
  action:string;
}
const ELEMENT_DATA: PeriodicElement[] = [];
@Component({
  selector: 'app-api-catalog-view',
  templateUrl: './api-catalog-view.component.html',
  styleUrls: ['./api-catalog-view.component.scss'],
})
export class ApiCatalogViewComponent implements OnInit {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  private incomingSearchText$ = new BehaviorSubject('');
  apiCatalogList: any = [
    {
      label: 'API Catalog',
      url: '/baseapp/api-catalog'
    }
  ];
  apiCatalogdisplayedColumns: string[] = ['api_product_name', 'api_Brand_name', 'type', 'api_business_object', 'method','select','action'];
  apiCatalogDataSource = new MatTableDataSource<PeriodicElement>();
  catalogselection = new SelectionModel<any>(true, []);
  // apiCatalogDataSource:any;
  token:any;
  page_min = 0;
  page_max = 10;
  total_records = 0;
  sortBy: string = "";
  orderBy: string = "DESC";
  search = "";
  loading = true;
  bubbleshow:boolean = false;
  bubble:any = [];
  bubbly: any;
  catEditEnable = false;
  catDeleteEnable = false;
  catDetailsEnable = false;
  catAddEnable = false
  importFile;
  userIp;
  importAndExportEnableFromENV: boolean;
  constructor(
    private backendService: BackendService,
    private router: Router,
    public storage: Storage,
    public menuService: MenuService,
    public alertController: AlertController,
    public helperService: HelperService,
    private matDialog: MatDialog,
    private http:HttpClient
  ) { }

  ngOnInit() {
    this.http.get('assets/feature_switching.json').subscribe((res: any) => {
      this.importAndExportEnableFromENV = res.importAndExportEnableFromENV;
    });

    this.helperService.getNavHelp().subscribe(toggle => {
      if(toggle){
        this.closebubblecross();
      }
    });
    this.getCatalog();
    this.incomingSearchText$.pipe(debounceTime(500)).subscribe((value) => {
      this.search = value;
      this.searchCatalog();
      this.getStorage().then((res)=>{
        if(res.showDialog == 1) this.bubbleshow = true;
        else this.bubbleshow = false;
      })
    })
    this.menuService.decodeToken().then(res =>{
      let permissions = res.permissions;
      permissions.map((e)=>{
        if(e.perm_mod == 'API_CAT_ADD') this.catAddEnable = true;
        if(e.perm_mod == 'API_CAT_EDIT') this.catEditEnable = true;
        if(e.perm_mod == 'API_CAT_DETAILS') this.catDetailsEnable = true;
        if(e.perm_mod == 'API_CAT_DELETE') this.catDeleteEnable = true;
      })
    })
    this.getUserIp();
    document.addEventListener("visibilitychange", () => {
      this.helperService.closeLoader();
    });
  }

  getCatalog(){
    // this.helperService.loader();
    this.getStorage().then((res)=>{
      let payload = {
        min: this.page_min,
        max: this.page_max,
        sort: this.sortBy,
        order: this.orderBy,
        q: this.search
      }
      this.backendService.PostAPICall('getApiCatalogue', payload, res.token).subscribe(
        (data) => {
          this.apiCatalogDataSource = new MatTableDataSource(data.records);
          // //console.log(this.apiCatalogDataSource)
          this.total_records = data.total_count;
          this.helperService.closeLoader();
          this.loading = false;

        },
        (error)=>{
          //console.log(error);
          this.loading = false;
          this.helperService.closeLoader();
          this.helperService.handleError(error);    
        }
      );
    })
  }

  searchCatalog(){
    this.getStorage().then((res)=>{
      let payload = {
        min: this.page_min,
        max: this.page_max,
        sort: this.sortBy,
        order: this.orderBy,
        q: this.search
      }
      this.backendService.PostAPICall('getApiCatalogue', payload, res.token).subscribe(
        (data) => {
          this.apiCatalogDataSource = new MatTableDataSource(data.records);
          this.total_records = data.total_count;
        },
        (error)=>{
          //console.log(error);
          this.helperService.handleError(error);
        }
      );
    })
  }

  async confirmDeleteAlert(header, msg, id) {
    const alert = await this.alertController.create({
      header: header,
      message: msg,
      buttons: [
        {
          text: 'CANCEL',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          }
        }, {
          text: 'OK',
          cssClass: 'primary-text',
          handler: () => {
            this.deleteCatalog(id)
          }
        }
      ]
    });
    await alert.present();
  }

  async getStorage () {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      showDialog: await this.storage.get("showDialog")
    }
    return data;
  }

  deleteCatalog(id){
    this.helperService.loader();
    this.getStorage().then((res)=>{
      let url = `/api/catalogue/deleteApiCatalogueSource/${id}`;
      this.backendService.DeleteAPICall(url, res.token).subscribe(
        (res) => {
          this.helperService.closeLoader();
          this.helperService.presentToast(res.msg, 2000);
          this.getCatalog();
        },
        (error)=>{
          //console.log(error);
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  async confirmCopyApiCatalogAlert(header,msg,element) {
    const alert = await this.alertController.create({
      header: header,
      message: msg,
      buttons: [
        {
          text: 'NO',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          },
        },
        {
          text: 'YES',
          cssClass: 'primary-text',
          handler: () => {
            this.copyApiCatalogDetailsAPI(element)
          },
        },
      ],
    });
    await alert.present();
  }

  copyApiCatalogDetailsAPI(element){
    this.getStorage().then((res) => {
      let payload = {
        id: element.id,
        created_by: res.userId,
        created_ip_address: element.created_ip_address
      };
      this.backendService
        .PostAPICall('copyApiCatalog', payload, res.token)
        .subscribe(
          (data) => {
            this.helperService.presentToast(data.msg,2000);
            this.getCatalog();
          },
          (error) => {
            //console.log(error);
            this.loading = false;
            this.helperService.handleError(error);
          }
        );
    });
  }

  confirmCopyApiCatalog(element) {
    const header = 'Confirm!';
    const msg = 'Are you sure you want to copy?';
    this.confirmCopyApiCatalogAlert(header, msg, element);
  }

  loadMore(event) {
    this.helperService.loader()
    // this.page_min = this.page_max;
    this.page_max = this.page_max + 10;
    let payload = {
      min: this.page_min,
      max: this.page_max,
      sort: this.sortBy,
      order: this.orderBy,
      q: this.search
    }
    this.getStorage().then((res)=>{
      this.backendService.PostAPICall('getApiCatalogue', payload, res.token).subscribe(
        data => {
          this.helperService.closeLoader();
          // this.apiCatalogDataSource = this.apiCatalogDataSource.concat(data.records);
          this.apiCatalogDataSource = new MatTableDataSource(data.records);
          // this.orgDataSource = this.orgDataSource.concat(data.records);
          event.target.complete();
          if(data.records.length == this.total_records){
            event.target.disabled = true;
            // this.helperService.presentToast('No more data', 2000);
          }
        },
        (error)=>{
          //console.log(error);
          event.target.complete();
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  searchStringMethod(message: string) {
		this.incomingSearchText$.next(message);
	}

  clearSearch(){
    this.search = "";
    this.searchStringMethod(this.search);
  }

  getSearchOnChange(e){
    this.searchStringMethod(e);
  }

  editCatalog(id){
    this.router.navigate(['baseapp/api-catalog/update', btoa(id)]);
  }

  catalogDetails(id){
    this.router.navigate(['baseapp/api-catalog/details', btoa(id)]);
  }

  confirmDelete(userId) {
    const header = 'Confirm!';
    const msg = "Are you sure you want to delete?"
    this.confirmDeleteAlert(header, msg, userId,)
  }

  onClickAddApiCatalog() {
    this.router.navigate(['baseapp/api-catalog/create']);
  }

  closebubblecross(){
    this.bubbleshow = false;
  }
  
  closebubble(){
    this.bubbleshow = false;
    sessionStorage.setItem("bubbly", "0");
  }

  onFileSelect(event) {
    const file: File = event.target.files[0];
    // Check file extension and MIME type
    const fileExtension = file.name.split('.').pop().toLowerCase();
    const mimeType = file.type;

    if (fileExtension !== 'csv' || mimeType !== 'text/csv') {
      this.helperService.presentToast("Please upload a csv file", 2000);
      return;
    }
    
    this.importFile = file;
    this.helperService.loader();
    this.getStorage().then((res)=>{
      const form: FormData = new FormData();
      form.append("Catalogue", this.importFile);
      this.backendService.PostInstanceAPICall('importApiCatalogue', form, res.token).subscribe(
      (data) => {
        if(data.inserted_catalog.length != 0) {
          this.helperService.presentToast("API catalog import successful", 2000);
        } else if(data.failed_catalog[0].error) {
          this.helperService.presentToast(data.failed_catalog[0].error, 2000);
        }
        
        this.helperService.closeLoader();
        this.getCatalog();
      },(error)=>{
        this.helperService.closeLoader();
        this.helperService.handleError(error);
      })
    })

  }

  checkIsAllCatalogSelected() {
    const numSelected = this.catalogselection.selected.length;
    const numRows = this.apiCatalogDataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  selectAllCatalog() {
    this.checkIsAllCatalogSelected() ?
        this.catalogselection.clear() :
        this.apiCatalogDataSource.data.forEach(row => this.catalogselection.select(row));
  }

  exportCatlog() {
    this.helperService.loader();
    let catalogselected = [];
      this.catalogselection.selected.forEach(s =>{
        catalogselected.push(s.id);
      });
      if(catalogselected.length > 0){
        this.getStorage().then((res)=>{
          let payload= {
            "id": catalogselected
          };
          this.backendService.PostAPICall('exportApiCatalogue', payload, res.token).subscribe((data) => {
            const base64String = data.data;
            const fileName = data.file_name;
            
            const binaryString = atob(base64String);

            const binaryLen = binaryString.length;
            const bytes = new Uint8Array(binaryLen);
            for (let i = 0; i < binaryLen; i++) {
              bytes[i] = binaryString.charCodeAt(i);
            }

            const blob = new Blob([bytes], { type: 'application/zip' });

            const currentDateTime = new Date();
            const dateString = currentDateTime.toLocaleDateString('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            }).replace(/\//g, '');
          
            const timeString = currentDateTime.toLocaleTimeString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: false
            }).replace(/[:.]/g, '');

            const zipFileName = fileName.replace('.csv', '_' + `${dateString}${timeString}` + '.zip');

            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = zipFileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.catalogselection.clear();
            this.helperService.closeLoader();
          },(error)=>{
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          })
        })
      } else {
        this.helperService.presentToast("Please select catalogs", 2000);      
      }
    
  }
  
  getUserIp() {
    this.backendService.getUserIp().subscribe(
      (data) => {
        const e: any = data as any;
        //console.log(e);
        this.userIp = e.ip;
      })
  }
}
